export const userListStyles = ({ palette }) => ({
  wrapper: {
    display: 'flex',
    minWidth: 500,
    gap: 16,
    alignItems: 'center',
  },
  nameWrapper: {
    lineHeight: 1,
    textTransform: 'capitalize',
  },
  rightBlock: {
    marginLeft: 'auto',
  },
  textTertiary: {
    color: palette.text.tertiary,
  },
  chip: {
    borderRadius: 8,
    background: palette.background.layer1,
  },
  managerBlock: {
    marginRight: 50,
  },
  labelsWrapper: {
    maxWidth: 430,
  },
  textEllipsis: {
    overflow: 'hidden', 
    textOverflow: 'ellipsis', 
    whiteSpace: 'nowrap',
  },
});
